import { Box } from 'components/Box/Box';
import { Divider } from 'components/Divider/Divider';
import { Image } from 'components/Image/Image';
import { StyledNativeLinkWithRef } from 'components/Link/StyledNativeLinkWithRef';
import { IdealistLogo } from 'components/Logo/IdealistLogo';
import { Body } from 'components/Text/Body';
import { H1 } from 'components/Text/H1';
import { HeadingSmall } from 'components/Text/HeadingSmall';
import { gutterWidth } from 'theme/theme';
import { getStaticImageSrc } from 'utils/getImageSrc';

type Props = {
  searchText?: string;
  searchUrl?: string;
  homePageUrl?: string;
  textOnly?: boolean;
};

export function NotFoundContent({
  searchText,
  searchUrl,
  homePageUrl,
  textOnly,
}: Props) {
  return (
    // @ts-expect-error TS(2322): Type 'false | ("block" | "flex" | null)[]' is not ... Remove this comment to see the full error message
    <Box display={!textOnly && ['block', null, 'flex']} alignItems="center">
      <Box
        // @ts-expect-error TS(2322): Type 'false | (number | null)[]' is not assignable... Remove this comment to see the full error message
        width={!textOnly && [1, null, 1 / 2]}
        // @ts-expect-error TS(2322): Type 'false | (number | null)[]' is not assignable... Remove this comment to see the full error message
        pr={!textOnly && [0, null, gutterWidth]}
      >
        <HeadingSmall color="lightContentGrey">
          {'404: '}
          {getText('Page Not Found')}
        </HeadingSmall>

        <H1>
          {
            /* TRANSLATORS: 404 page title */
            getText(`Well, this isn't ideal...`)
          }
        </H1>

        <Body>
          {
            /* TRANSLATORS: 404 page copy */
            getText(`Sorry, we couldn't find the page you were looking for.
          The link you followed may be broken, or the page may have been removed.
          Try the following options:`)
          }
        </Body>

        <Box mt={(gutterWidth * 3) / 4}>
          <StyledNativeLinkWithRef href={searchUrl || `/jobs`}>
            <Box display="flex" alignItems="center">
              <Box transform="translateY(3px)">
                <Image
                  src={getStaticImageSrc('magifying-glass.png')}
                  alt="magnifying glass"
                  width={24}
                />
              </Box>
              <Box ml={24}>
                {searchText ||
                  (searchUrl
                    ? getText('Search the site')
                    : getText('Search jobs'))}
              </Box>
            </Box>
          </StyledNativeLinkWithRef>

          <Divider marginTop={gutterWidth / 2} marginBottom={gutterWidth / 2} />

          <StyledNativeLinkWithRef href={homePageUrl || '/'}>
            <Box display="flex" alignItems="center">
              <Box transform="translateY(3px)">
                <IdealistLogo height={24} />
              </Box>
              <Box ml={24}>{getText('Go to the homepage')}</Box>
            </Box>
          </StyledNativeLinkWithRef>

          <Divider marginTop={gutterWidth / 2} marginBottom={gutterWidth / 2} />

          <StyledNativeLinkWithRef href="https://www.idealist.org/en/about/contact">
            <Box display="flex" alignItems="center">
              <Box transform="translateY(3px)">
                <Image
                  src={getStaticImageSrc('phone.png')}
                  alt="phone"
                  width={24}
                />
              </Box>
              <Box ml={24}>{getText('Contact Support')}</Box>
            </Box>
          </StyledNativeLinkWithRef>
        </Box>
      </Box>

      {!textOnly && (
        <Box
          position="relative"
          height="100%"
          width={[1, null, 1 / 2]}
          mt={[gutterWidth, null, 0]}
        >
          <Image src={getStaticImageSrc('not-found.svg')} alt="Illustration" />
        </Box>
      )}
    </Box>
  );
}
